module.exports = __webpack_public_path__ + "static/media/prLogo.3ea774a5.png";